document.addEventListener('DOMContentLoaded', () => {
  const btn  = document.querySelector('#LoadMore');
  const grid = document.querySelector('#ProductsList');
  if (!btn || !grid) return;

  const revealCard = (el) => {
    el.classList.add('ajax-loaded');
    el.style.visibility = 'visible';
    el.style.opacity = '1';
    el.style.transform = 'translateY(0)';
    el.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
  };

  const hiddenCards = () => {
    const all = grid.querySelectorAll('.f-column.card');
    return Array.from(all).filter(el => {
      const cs = getComputedStyle(el);
      return cs.visibility === 'hidden' || cs.opacity === '0' || el.hasAttribute('hidden');
    });
  };

  const dedupHas = (id) => id && !!grid.querySelector(`.f-column.card[data-product-id="${id}"]`);

  const appendFromSectionHTML = (html) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;

    // 1) apanhar cards novos
    const incoming = temp.querySelectorAll('.f-column.card');
    let appended = 0;

    incoming.forEach(card => {
      const pid = card.getAttribute('data-product-id');
      if (dedupHas(pid)) return;

      // força visibilidade + fade-in
      card.style.opacity = '0';
      card.style.visibility = 'visible';
      card.style.transform = 'translateY(20px)';
      card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';

      grid.appendChild(card);
      requestAnimationFrame(() => {
        card.style.opacity = '1';
        card.style.transform = 'translateY(0)';
      });
      appended++;
    });

    // 2) atualizar próximo data-next-url lendo o botão devolvido pela própria section
    const nextBtn = temp.querySelector('#LoadMore');
    if (nextBtn && nextBtn.dataset.nextUrl) {
      btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
      btn.disabled = false;
      btn.textContent = 'Load More';
    } else {
      btn.remove(); // acabou
    }

    // 3) re-disparar scripts do tema
    document.dispatchEvent(new Event('theme:load'));
    document.dispatchEvent(new Event('shopify:section:load'));
    if (window.Sleek?.lazyLoad?.update) { try { window.Sleek.lazyLoad.update(); } catch(e) {} }

    return appended;
  };

  btn.addEventListener('click', async () => {
    // 1) revela o que já está no DOM mas oculto (caso dos teus 2 itens “faltantes”)
    const hidden = hiddenCards();
    if (hidden.length > 0) {
      hidden.forEach(revealCard);
      return;
    }

    // 2) senão, vai buscar próxima página da SECTION (não view)
    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) { btn.remove(); return; }

    btn.disabled = true;
    btn.textContent = 'A carregar...';

    try {
      const res = await fetch(nextUrl, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();
      const appended = appendFromSectionHTML(html);

      if (appended === 0 && !btn.dataset.nextUrl) {
        btn.remove();
      } else if (btn.dataset.nextUrl) {
        btn.disabled = false;
        btn.textContent = 'Load More';
      }
    } catch (e) {
      console.error('Load More error:', e);
      btn.disabled = false;
      btn.textContent = 'Tentar novamente';
    }
  });
});

console.log('load-more.js (Section Rendering API)');
